import { useEffect, useState } from 'react';
import {
  Nav,
  Navbar,
  Button,
  Container,
  Row,
  Col,
  Card,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getImgCalendarCutoff } from '../../../services/ApiGetCalendarImgCutoff';
import { ImgPreview } from '../../../model/datatype';
import { protectedResources } from '../../../authConfig';
import { CalendarModal } from '../../../modal/CalendarModal';

export const PayrollCutoffLastDowload = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalBackdrop, setModalBackdrop] = useState('true');
  const [modalKeyboard, setModalKeyboard] = useState(true);
  const [modalTitle, setModalTitle] = useState('');
  const [modalBody, setmodalBody] = useState('');
  const [modalConfirm, setModalConfirm] = useState(false);

  let { t } = useTranslation();
  const [data, setData] = useState<ImgPreview | null>(null);
  useEffect(() => {
    // Use sessionStorage cache for fast load
    const cache = sessionStorage.getItem('payroll_cutoff_img');
    if (cache) {
      setData(JSON.parse(cache));
    } else {
      getImgCalendarCutoff().then((response) => {
        if (response) {
          setData(response);
          sessionStorage.setItem('payroll_cutoff_img', JSON.stringify(response));
        }
      });
    }
  }, []);

  function handleView(e: any) {
    setModalTitle(t('CalendarPupup'));
    setmodalBody(data?.cutOffCalendar?.image ? "data:image/jpg;base64," + data.cutOffCalendar.image : '');
    setModalBackdrop('true');
    setModalKeyboard(false);
    setModalConfirm(false);
    setShowModal(true);
  }

  const handleLogout = () => {
    setShowModal(false);
  };

  return (
    <>
      <CalendarModal
        btnConfirm="no"
        onExiting=""
        btnText={t('btn_CloseWindow')}
        type="images"
        keyboard={modalKeyboard}
        backdrop={modalBackdrop}
        confirm={modalConfirm}
        confirmFunc=""
        title={modalTitle}
        body={modalBody}
        showModal={showModal}
        handleContinue={handleLogout}
        onHide={() => setShowModal(false)}
        Style={{ background: '' }}
      />
      <div className="time-detail-box payrollCutoff-dowload mb-10 mt-3">
        <Container>
          <Row>
            <Col className=" px-1">
              <div className="PayrollCutoffLastDowload">
                <Row>
                  <Col xs={5}>
                    <div className="PayrollCutoffLastDowload-img ml-4">
                      <img title="image" src="../images/salary.png" width={80} />
                    </div>
                  </Col>
                  <Col xs={7} className="text-end">
                    <div
                      className="payroll-last-download mt-3 mb-3"
                      onClick={handleView}
                    >
                      {t('view')}
                    </div>
                    <p className="payroll-last-download-text">
                      {t('veiw_text')}
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
